module.exports = __webpack_public_path__ + "static/textNo-f110998349e919589f47ba7cb376d8e6.png";